import { graphql } from "gatsby"
import { GatsbyImage, GatsbyImageProps, IGatsbyImageData } from "gatsby-plugin-image"
import React from "react"
//import * as styles from "./DatoImage.module.scss"

/**
 * Focal point "boost" calculator. Converts focalpoint values (0-1) to CSS objectPosition values (0-100) with a boost.
 * Boost is used as a multiplier to move focalpoint further away from center which suits most "normal" images better(?)
 * @param num
 * @param boost
 * @returns
 */
function focalpointToCssPos(num: number, boost = 1.5) {
  return Math.min(Math.max((num - 0.5) * boost + 0.5, 0), 1) * 100
}

/**
 * Välikerros kuvan käsittelyyn, jotta helpompi päivittää uuteen plugariin aikanaan.
 */
export type DatoImageProps = Omit<GatsbyImageProps, "image"> & {
  focalPoint?: { x: number; y: number } | null
  image?: IGatsbyImageData | Record<string, unknown> | null
}

const DatoImage = (props: DatoImageProps) => {
  // console.debug("Rendering DatoImage", props)

  const { focalPoint, alt = "", ...rest } = props

  if (!props.image) {
    // console.error("Tried to render DatoImage without image prop")
    return null
  }

  // boostataan focalpointin sijaintia kauemmas keskustasta, jolloin "normaalin" muotoiset kuvat rajautuu lähemmäs tavoitetta
  // TODO miksi käytetään CSS objectPosition? Miksi ylipäätään tarpeellinen?
  const imgStyle = focalPoint
    ? {
        ...props.imgStyle,
        objectPosition: `${focalpointToCssPos(focalPoint.x)}% ${focalpointToCssPos(focalPoint.y)}%`,
      }
    : props.imgStyle

  const image: IGatsbyImageData = {
    ...(props.image as IGatsbyImageData),
    images: {
      ...(props.image as IGatsbyImageData).images,
    },
  }
  /**
   * Korjaus GatsbyImagen / Dato source pluginin bugiin:
   * Jos kuvan tyyppi on (Datossa) image/tif, kuva ei tule näkyviin sivulle, vaikka source oikeasti tulee datocsm.asset.com CDN:stä jpg/webp/avif muodossa.
   * Epäselvää miksi tämä tehdää juuri näin.
   */
  if (image.images && !image.images.fallback && image.images.sources?.[0]) {
    // deep clone to avoid mutating props by reference
    image.images.fallback = {
      sizes: "100vw",
      src: image.images?.sources[0].srcSet.split(" ")[0],
      srcSet: image.images.sources[0].srcSet,
    }
  }

  return <GatsbyImage alt={alt} {...rest} image={image} imgStyle={imgStyle} />
}

export default DatoImage

export const query = graphql`
  fragment DatoImageDefault on DatoCmsFileField {
    alt
    image: gatsbyImageData(width: 1000, placeholder: BLURRED, layout: FULL_WIDTH)
    focalPoint {
      x
      y
    }
  }
`
